var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap-container',[_c('select-options',{attrs:{"label":"Motivo","title":"¿Cuál es el motivo de la solicitud?"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }